export const IMPRESSION = {
    EVENT_TYPE: 'tailored_home_page_impression',
    EVENT_TYPE_ROLE_CARD: 'tailored_home_page_role_card_impression',
    PAGE_NAME: 'tailored_home_page',
    GROUP: 'components_impressions',
};

export const tagTypes = {
    TAG_TYPE_UNSPECIFIED: 0,
    TAG_TYPE_SKILL: 1,
    TAG_TYPE_SERVICE: 2,
};

export const assetTypes = {
    ASSET_TYPE_UNSPECIFIED: 0,
    ASSET_TYPE_IMAGE: 1,
    ASSET_TYPE_VIDEO: 2,
    ASSET_TYPE_PDF: 3,
    ASSET_TYPE_AUDIO: 4,
};

export const badgeTypes = {
    BADGE_UNSPECIFIED: 0,
    BADGE_BUY_IT_AGAIN: 1,
    BADGE_FEATURED: 2,
    BADGE_FIVERR_CHOICE: 3,
    BADGE_NEW_ARRIVAL: 4,
    BADGE_PRO: 5,
    BADGE_STUDIO: 6,
    BADGE_PROMOTED_GIG: 7,
    BADGE_RISING_TALENT: 8,
    BADGE_SELLER_COUNTRY_FLAG: 9,
    BADGE_VETTED: 10,
    BADGE_PRO_VETTED: 11,
    BADGE_OFFER_CONSULTATION: 12,
    BADGE_SELLER_LEVEL_NO_LEVEL: 13,
    BADGE_SELLER_LEVEL_ONE: 14,
    BADGE_SELLER_LEVEL_TWO: 15,
    BADGE_SELLER_LEVEL_TOP_RATED: 16,
};

export const sellerLevelTypes = {
    SELLER_LEVEL_UNSPECIFIED: 0,
    SELLER_LEVEL_ONE: 1,
    SELLER_LEVEL_TWO: 2,
    SELLER_LEVEL_TOP_RATED: 3,
    SELLER_LEVEL_NEW_ARRIVAL: 4,
    SELLER_LEVEL_NO_LEVEL: 5,
};
